export default __webpack_public_path__ + "static/media/question-mark-circle.e4a5faf5.svg";